/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { Card, Tabs, CardContent, Tab, Divider } from '@mui/material';
import { Schedule } from '@mui/icons-material';
import EmailOpensHeatmap from '../charts/EmailOpensHeatmap';
import ReportsCardHeader from '../cards/ReportsCardHeader';

const SurveyTabbedHeatmap = ({ actions }) => {
    const [tab, setTab] = useState('Survey Open');
    const [data, setData] = useState(null);

    const generateHeatmapData = () => {
        const filteredData = Object.values(
            actions
                .filter(item => item.actionType === tab)
                .reduce((acc, { dateTime }) => {
                    const date = new Date(dateTime);
                    const jsDay = date.getDay(); // 0 = Sunday, 6 = Saturday
                    const dayOfWeek = (jsDay + 6) % 7; // convert: 0 = Monday, 6 = Sunday
                    const hour = date.getHours();

                    const key = `${dayOfWeek}-${hour}`;

                    acc[key] = acc[key] || { dayOfWeek, hour, totalOpens: 0 };
                    acc[key].totalOpens += 1;

                    return acc;
                }, {})
        );

        setData(filteredData);
    };

    useEffect(() => {
        generateHeatmapData();
    }, [tab]);

    return (
        <Card sx={{ height: '100%' }}>
            <ReportsCardHeader
                title="Peak Engagement Heatmap"
                icon={<Schedule />}
            />
            <CardContent
                sx={{
                    m: 0,
                    p: 0,
                    '&:last-child': {
                        paddingBottom: 0
                    }
                }}
            >
                <Tabs
                    value={tab}
                    onChange={(e, value) => setTab(value)}
                    variant="fullWidth"
                >
                    <Tab label="Opens" value="Survey Open" />
                    <Tab label="Completions" value="Survey Completed" />
                </Tabs>
                <Divider />
                <EmailOpensHeatmap data={data} />
            </CardContent>
        </Card>
    );
};

export default SurveyTabbedHeatmap;